// extracted by mini-css-extract-plugin
module.exports = {"button":"page-error-contents_button___aigF"};